export default {"src":"/_next/static/media/letter.1f51c88a.svg","height":12,"width":16};